const isQq = () => {
  const { userAgent } = navigator
  if (/qq/i.test(userAgent)) {
    return true
  }
  return false
}
exports.isQq = function() {
  return isQq()
}



// WEBPACK FOOTER //
// ./src/common/isQq.js